import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import OwlCarousel from 'react-owl-carousel';
import { price } from '../Helpers';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useSelector, useDispatch } from "react-redux";
import PayUForm from '../Utils/PayUForm';

function Checkout() {
    const [cart, setCart] = useState([]);
    const [errors, setErrors] = useState(false);
    const [states, setStates] = useState(false);
    const [cities, setCities] = useState(false);
    const [payuData, setPayuData] = useState(false);
    const navigate = useNavigate();
    let cartRaw = useSelector((state) => state.data?.cart);

    const handlePlaceOrder = async (e) => {
        e.preventDefault();
        const form = e.target;
        let jsonData = {};
        let errorData = {};
        Array.from(form.elements).forEach((item) => {
            if (item.name) {
                if (item.value == "" && item.getAttribute("requiredField")) {
                    errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
                }
                jsonData[item.name] = item.value;
            }
        });
        if (form.paymentType) {
            const selected = Array.from(form.paymentType).find(el => el.checked);
            if (selected) {
                jsonData.paymentType = selected.value;
            }
            else {
                errorData["paymentType"] = "Payment Type is required";
            }
        }
        if (Object.entries(errorData).length > 0) {
            setErrors(errorData);
        }
        else {
            try {
                jsonData.cartData = JSON.parse(localStorage.getItem("cart"));
                const response = await axios.post('/product/checkout', jsonData);
                const { status, message, hashData } = response.data;
                toast(message);
                if (status) {
                    if (hashData) {
                        const payuData = {
                            hash: hashData.hash,
                            txnid: hashData.txId,
                            amount: hashData.amount,
                            firstname: jsonData.firstName,
                            email: jsonData.email,
                        };
                        setPayuData(payuData);
                    }
                    else {
                        localStorage.removeItem("cart");
                        //navigate('/bazaar/orderSuccess');
                        window.location.href = "/bazaar/orderSuccess";
                    }
                }
            } catch (error) {
                if (error?.response?.data?.message) {
                    toast(error.response.data.message);
                }
            }
        }
    };

    const getStates = async (e) => {
        const response = await axios.post('/v2/remittance/get/states', { country: e.target.value });
        const { status, data } = response.data;
        if (status) {
            setStates(data);
        }
    };

    const getCities = async (e) => {
        const response = await axios.post('/v2/remittance/get/district', { state: e.target.value });
        const { status, data } = response.data;
        if (status) {
            setCities(data);
        }
    };

    function addSpaceBetweenCases(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2');
    };

    useEffect(() => {
        let parsedCart = [];
        if (typeof cartRaw === "string") {
            try {
                parsedCart = JSON.parse(cartRaw);
            } catch (e) {
                console.error("Invalid JSON in cartRaw:", cartRaw);
            }
        }
        setCart(parsedCart);
    }, [cartRaw]);
    return (
        <>
            {
                payuData && (
                    <PayUForm formData={payuData} autoSubmit={true} />
                )
            }
            <div class="breadcrumb-option">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="breadcrumb__links">
                                <Link to="/bazaar"><i class="fa fa-home"></i> Home</Link>
                                <span>Checkout</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section class="checkout spad">
                <div class="container">
                    <form className="checkout__form" onSubmit={handlePlaceOrder}>
                        <div class="row">
                            <div class="col-lg-8">
                                <h5>Billing detail</h5>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>First Name <span>*</span></p>
                                            <input type="text" name="firstName" requiredField="true" />
                                            <span className="error">{errors && errors?.firstName}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>Last Name <span>*</span></p>
                                            <input type="text" name="lastName" requiredField="true" />
                                            <span className="error">{errors && errors?.lastName}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="checkout__form__input">
                                            <p>Address <span>*</span></p>
                                            <input type="text" placeholder="Address" name="address" requiredField="true" />
                                            <span className="error">{errors && errors?.address}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>Country <span>*</span></p>
                                            <select name="country" onChange={getStates} requiredField="true">
                                                <option value="">--Select--</option>
                                                <option value="India">India</option>
                                            </select>
                                            <span className="error">{errors && errors?.country}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>Country/State <span>*</span></p>
                                            <select name="state" onChange={getCities} requiredField="true">
                                                <option value="">--Select--</option>
                                                {
                                                    states && states.map((state) => (
                                                        <option value={state}>{state}</option>
                                                    ))
                                                }
                                            </select>
                                            <span className="error">{errors && errors?.state}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>Town/City <span>*</span></p>
                                            <select name="city" requiredField="true">
                                                <option value="">--Select--</option>
                                                {
                                                    cities && cities.map((city) => (
                                                        <option value={city}>{city}</option>
                                                    ))
                                                }
                                            </select>
                                            <span className="error">{errors && errors?.city}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>Postcode/Zip <span>*</span></p>
                                            <input type="number" name="postcode" requiredField="true" />
                                            <span className="error">{errors && errors?.postcode}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>Phone <span>*</span></p>
                                            <input type="number" name="phone" requiredField="true" />
                                            <span className="error">{errors && errors?.phone}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="checkout__form__input">
                                            <p>Email <span>*</span></p>
                                            <input type="email" name="email" requiredField="true" />
                                            <span className="error">{errors && errors?.email}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="checkout__form__input">
                                            <p>Oder notes </p>
                                            <input type="text"
                                                placeholder="Note about your order, e.g, special note for delivery" name="notes" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="checkout__order">
                                    <h5>Your order</h5>
                                    <div class="checkout__order__product">
                                        <ul>
                                            <li>
                                                <span class="top__text">Product</span>
                                                <span class="top__text__right">Total</span>
                                            </li>
                                            {
                                                cart && cart.map((product, index) => (
                                                    <li>{index + 1}. {product.productName} ({price(product.price, product.discountInPercent)} * {product.quantity})<span>₹{price(product.price, product.discountInPercent) * product.quantity}</span></li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                    <div class="checkout__order__total">
                                        <ul>
                                            {/* <li>Subtotal <span>$ 750.0</span></li> */}
                                            <li>Total <span>₹{cart.reduce((sum, item) => sum + (parseFloat(price(item.price, item.discountInPercent)) * parseFloat(item.quantity)), 0)}</span></li>
                                            <li>Shipping Charges Extra</li>
                                        </ul>
                                    </div>
                                    <div class="checkout__order__widget">
                                        <label for="online">
                                            Online Payment
                                            <input type="radio" name="paymentType" value="online" id="online" />
                                            <span class="checkmark"></span>
                                        </label>
                                        <label for="cod">
                                            Cash On Delevery
                                            <input type="radio" name="paymentType" value="cod" id="cod" />
                                            <span class="checkmark"></span>
                                        </label>
                                        <span className="error">{errors && errors?.paymentType}</span>
                                    </div>
                                    <button type="submit" class="site-btn">Place Order</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}

export default Checkout;
